import { ReactourStep } from 'reactour';
import { ImageStepWrapper } from '@components/shared';

interface UserTourSteps {
  editTimetable: ReactourStep[];
  studentViewTimetable: ReactourStep[];
  staffViewTimetable: ReactourStep[];
}

const TimetableWelcomeStep = () => {
  return (
    <ImageStepWrapper>
      <img
        className="bot"
        src="/images/bots/normal-bot.svg"
        alt="Bot"
        style={{
          height: 200,
        }}
      />
      This is one of the most important parts of this system! This page will allow you to manage the timetable of your
      institute.
    </ImageStepWrapper>
  );
};

export const timetableTourSteps: UserTourSteps = {
  editTimetable: [
    {
      selector: '',
      content: <TimetableWelcomeStep />,
    },
    {
      selector: '.timetable-week',
      content: 'Start by selecting a week.',
    },
    {
      selector: '#timetable-batch-class',
      content: 'Next select the batch and the class you want to edit.',
    },
    {
      selector: '#timetable-academic-calendar',
      content:
        'This button will allow you to view all the academic calendar items available for the selected batch in the selected week.',
    },
    {
      selector: '#timetable-configuration',
      content:
        "This button will allow you to set a pre defined template of time slots and set intervals. When you set timeslots, you can easily drag and drop items into them and the item will take the predefined time slot's values.",
    },
    {
      selector: '#timetable-reset',
      content:
        "☢️ This will reset the timetable of the selected week. Which means it will clear all the items. But it won't save the cleared timetable. ⚠️ You have to manually save it by clicking the Save button",
    },
    {
      selector: '.publish-check',
      content: "The timetable will be visible to the lecturers and students only if it's published.",
    },
    {
      selector: '#timetable-save',
      content: 'This button will save the information to the database.',
    },
    {
      selector: '#timetable-subject-blocks',
      content: 'This section will show all the available subjects and their extra slots (Exams, Practicals, etc).',
    },
    {
      selector: '#timetable-subject-blocks',
      content: '⚠️ Please note that only the subjects which have a lecturer assigned will be shown here.',
    },
    {
      selector: '#timetable-subject-blocks',
      content:
        'First click on an item you want to drag to select it. Then again click and (without releasing the click) drag it over to the timeline below.',
    },
    {
      selector: '#timetable-subject-blocks',
      content:
        "The count here will show you how many slots the subject have according to it's initial configurations. You can use this as a guide but can always add extra.",
    },
    {
      selector: '#timetable-lecturer-blocks',
      content:
        "This section will allow you to assign a lecturer to the selected item. You can select a lecturer before dragging or after they are dragged to the timeline below. First you'll have to select the item before assigning a lecturer.",
    },
    {
      selector: '#timetable-location-blocks',
      content:
        "This section will allow you to set a location for the items. For example, Subject A will be taught in classroom B. You'll have to first select the item from the timeline below or you can also set the location before dragging.",
    },
    {
      selector: '#timetable-timeline',
      content:
        "Once you place an item in the timeline, you can drag it, resize it and even change it's time by clicking on it twice. ⚠️ Remember, clicking twice! Not double click. The first click will select the item. This will be indicated by a yellow border. Clicking on it again will allow you to edit it's time.",
    },
    {
      selector: '#timetable-timeline',
      content:
        'You can delete an item by clicking on it (This will be indicated by a yellow border) and then pressing the delete key on your keyboard.',
    },
    {
      selector: '',
      content: "Phew that's a lot! Finally, use this page wisely!",
    },
  ],
  studentViewTimetable: [
    {
      selector: '',
      content: 'This page will show your timetable.',
    },
  ],
  staffViewTimetable: [
    {
      selector: '',
      content: 'This page will show your timetable.',
    },
    {
      selector: '',
      content: 'Clicking on an item will take you to the attendance form.',
    },
  ],
};
